// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"8ef65d9a2915defb8bac","655":"fcab69db8123e22f0af4"}[chunkId] + ".js";
};